import React from 'react';
import { Page } from 'react-pdf';

export const MemoPage = React.memo(
  Page,
  (prev, next) => prev.pageNumber === next.pageNumber
);
